import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserPlanQuotaResponse } from '@edtech-ui/core/models/free-plan-usages/get-free-plan-usages';
import { UpgradePlanContactPaylod, UpgradePlanContactResponse } from '@edtech-ui/core/models/upgrade-plan/upgrade-plan';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class UsagePlanService {

	apiUrl = environment.usagePlanApiUrl;

	constructor(private readonly http: HttpClient) { }

	getUsagePlan(): Observable<UserPlanQuotaResponse> {
		return this.http.get<UserPlanQuotaResponse>(`${this.apiUrl}/getUserUsage`);
	}

	postUpgradeUsagePlan(payload:UpgradePlanContactPaylod):Observable<UpgradePlanContactResponse>{
		return this.http.post<UpgradePlanContactResponse>(`${this.apiUrl}/contact`, payload);
	}
}